import script from "./KnowledgeBaseManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./KnowledgeBaseManagement.vue?vue&type=script&setup=true&lang=js"

import "./KnowledgeBaseManagement.vue?vue&type=style&index=0&id=75280ea9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75280ea9"]])

export default __exports__